module.exports = __webpack_public_path__ + "img/act_intro.7908c965.png";